<template>
    <div class="cinema-page page" ref="cinemaPage">
        <div class="search">
            <div class="wrap">
                <img class="img-s" :src="require('@/assets/icons/icon-search.png')" />
                <input
                    class="ipt"
                    placeholder="请输入影院名称或地址"
                    ref="searchRef"
                    v-model="searchText"
                />
                <img
                    class="img-r"
                    v-if="searchText.length > 0"
                    @click="clearSearch"
                    :src="require('@/assets/icons/icon-clear.png')"
                />
            </div>
        </div>
        <div class="select-bar">
            <div class="cell" @click="openRegion">
                <div class="picker">
                    <span class="pickername">{{ regionList[regionIndex].name }}</span>
                    <img class="img" :src="require('@/assets/icons/icon-down-triangle.png')" />
                </div>
            </div>
            <div class="cell" @click="openBrand">
                <div class="picker">
                    <span class="pickername">{{ brandList[brandIndex].name }}</span>
                    <img class="img" :src="require('@/assets/icons/icon-down-triangle.png')" />
                </div>
            </div>
        </div>
        <div class="list iphone-x-adaptation">
            <div
                class="cell"
                v-for="(item, index) in cinemaList"
                @click="toCinemaInfo(item)"
                :key="index"
            >
                <div class="name">
                    <div class="txt">{{ item.name }}</div>
                    <span class="distance">{{ item.distance }}</span>
                </div>
                <div class="addr">
                    <span class="txt">{{ item.address }}</span>
                </div>
                <div class="lab-list">
                    <div class="lab-item subsidy" v-if="item.showType == 1">
                        <img class="image" src="~@/assets/icons/icon-subsidy.png" />
                    </div>
                    <template v-if="item.enableCompetition == 1">
                        <div class="lab-item red">精品影院</div>
                        <div class="lab-item blue">极速出票</div>
                        <div class="lab-item green">出票率高</div>
                    </template>
                </div>
            </div>
            <div class="noList" v-if="cinemaList.length == 0">无搜索结果</div>
            <Scroll :onBottom="onBottom" />
        </div>
        <div class="location iphone-x-adaptation">
            <div>
                <span class="txt">定位：{{ currentCityName }}</span>
                <div class="rs-lc" :class="{ loading: againLocationStatus }" @click="againLocation">
                    重新定位
                </div>
            </div>
        </div>
        <Share v-if="!$store.state.common.platformId" />
    </div>
</template>
<script>
import { GET_CITY_REGION_LIST, GET_CINEMA_BRAND_LIST, GET_MOVIE_FOR_CINEMA_LIST } from 'api';
import { PAGE_CINEMA_INFO } from 'page';
import Share from '@/components/share';
import Scroll from '@/components/scroll';
export default {
    data() {
        return {
            searchText: '',
            regionList: [{}],
            regionIndex: 0,
            brandList: [{}],
            brandIndex: 0,
            cinemaList: [],
            pageIndex: 1,
            pageSize: 20,
            isBottom: false,
            againLocationStatus: false,
            isLoad: false,
            isOpenBack: false,
        };
    },
    components: {
        Scroll,
        Share,
    },
    computed: {
        cityId() {
            return this.$store.getters.getCurrentLocation.city.id || 0;
        },
        cityName() {
            return this.$store.getters.getCurrentLocation.city.name || '未定位';
        },
        currentCityName() {
            return this.$store.state.location.currentLocation.city.name || '未定位';
        },
        lon() {
            return this.$store.getters.getCurrentLocation.lon;
        },
        lat() {
            return this.$store.getters.getCurrentLocation.lat;
        },
    },
    watch: {
        cityId() {
            this.getArea();
            this.getList();
        },
        cityName(val) {
            this.pageIndex = 1;
            this.cinemaList = [];
            this.getArea();
            this.getList();
        },
        searchText(val) {
            this.pageIndex = 1;
            this.cinemaList = [];
            this.getList();
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (vm.brandList.length == 0 || vm.cinemaList.length == 0) {
                vm.$util.debounce(vm.init)();
            }
        });
    },
    mounted() {
        if (this.$route.query.type == 1) {
            this.$refs.searchRef.focus();
        }
    },
    created() {
        this.$util.debounce(this.init)();
    },
    methods: {
        init() {
            this.getBrandList();
            if (this.cityId) {
                this.getArea();
                this.getList();
            }
        },
        // 去影院详情
        toCinemaInfo(item) {
            this.$util.pageJump(PAGE_CINEMA_INFO, {
                titleName: item.name,
                cinemaId: item.id,
            });
        },
        // 获取影院列表
        getList() {
            const {
                lon,
                lat,
                cityId,
                regionList,
                regionIndex,
                brandList,
                brandIndex,
                searchText,
                pageIndex,
                pageSize,
            } = this;
            this.$util
                .post(GET_MOVIE_FOR_CINEMA_LIST, {
                    lon,
                    lat,
                    cityId,
                    regionId: regionList[regionIndex].id || null,
                    cinemaName:
                        searchText || (brandIndex == 0 ? '' : brandList[brandIndex].keyWord),
                    pageIndex,
                    pageSize,
                    cinemaShowType: this.$store.getters.getExposeMethod.cinemaShowType || null,
                })
                .then(res => {
                    if (res.success) {
                        if (res.data.length < pageSize) {
                            this.isBottom = true;
                        } else {
                            this.isBottom = false;
                        }
                        this.cinemaList = [...this.cinemaList, ...res.data];
                    }
                });
        },
        clearSearch() {
            this.searchText = '';
        },
        // 获取品牌列表
        getBrandList() {
            this.$util.post(GET_CINEMA_BRAND_LIST).then(res => {
                if (res.success) {
                    res.data.unshift({
                        name: '品牌',
                        id: '',
                        keyWord: '',
                    });
                    this.brandList = res.data;
                }
            });
        },
        // 重新获取定位
        againLocation() {
            if (!this.againLocationStatus) {
                this.againLocationStatus = true;
                this.$util.getLocation({
                    callback: res => {
                        this.againLocationStatus = false;
                        if (res.success) {
                            this.$store.commit('setSelectLocation', res.data);
                            if (res.data.city.name == this.cityName) {
                                this.pageIndex = 1;
                                this.cinemaList = [];
                                this.getArea();
                                this.getList();
                            }
                        }
                    },
                });
            }
        },
        // 获取下级区域
        getArea() {
            this.$util
                .post(GET_CITY_REGION_LIST, {
                    id: this.cityId,
                })
                .then(res => {
                    if (res.success) {
                        res.data.unshift({
                            name: this.cityName,
                            id: '',
                        });
                        this.regionList = res.data;
                    }
                });
        },
        // 打开区列表
        openRegion() {
            this.$picker.open({
                list: this.regionList,
                keyName: 'name',
                confirm: (item, index) => {
                    this.regionIndex = index;
                    this.$picker.close();
                    this.pageIndex = 1;
                    this.cinemaList = [];
                    this.getList();
                },
            });
        },
        // 打开品牌列表
        openBrand() {
            this.$picker.open({
                list: this.brandList,
                keyName: 'name',
                confirm: (item, index) => {
                    this.brandIndex = index;
                    this.$picker.close();
                    this.pageIndex = 1;
                    this.cinemaList = [];
                    this.getList();
                },
            });
        },
        //防止页面后退
        fobiddeBack() {
            if (!this.isOpenBack) {
                console.log('%c防止页面后退', 'color:#da2f33');
                this.isOpenBack = true;
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.backCommon);
            }
        },
        //启用浏览器返回
        enableBack() {
            if (this.isOpenBack) {
                console.log('%c启用浏览器返回', 'color:#da2f33');
                this.isOpenBack = false;
                history.go(-1);
                window.removeEventListener('popstate', this.backCommon);
            }
        },
        backCommon() {
            this.$util.closeWindow();
            history.pushState(null, null, document.URL);
        },
        // 触底事件
        onBottom() {
            if (this.isBottom) {
                return;
            }
            this.pageIndex++;
            this.getList();
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
.cinema-page {
    flex-direction: column;
    width: 100%;
    .search {
        padding: .pxToRem(20) [];
        .wrap {
            height: .pxToRem(66) [];
            display: flex;
            flex-direction: row;
            background: rgba(0, 0, 0, 0.05);
            border-radius: .pxToRem(33) [];
            align-items: center;
            .ipt {
                background: rgba(0, 0, 0, 0);
                flex: 1;
                padding: .pxToRem(13) [] 0;
                padding-left: .pxToRem(20) [];
                font-size: .pxToRem(28) [];
                height: .pxToRem(40) [];
                line-height: .pxToRem(40) [];
            }
            .img-s {
                .sq(32);
                margin-left: .pxToRem(24) [];
            }
            .img-r {
                .sq(32);
                padding: .pxToRem(17) [];
                padding-right: .pxToRem(24) [];
            }
        }
    }
    .select-bar {
        display: flex;
        flex-direction: row;
        height: .pxToRem(88) [];
        line-height: .pxToRem(88) [];
        padding: 0 .pxToRem(30) [];
        .cell {
            flex: 1;
            text-align: center;
            .picker {
                height: 100%;
            }
            .pickername {
                font-size: .pxToRem(28) [];
            }
        }
        .img {
            width: .pxToRem(32) [];
            height: .pxToRem(32) [];
            vertical-align: middle;
            margin-left: .pxToRem(24) [];
            margin-top: .pxToRem(-4) [];
        }
    }
    .list {
        padding: 0 .pxToRem (30) [];
        padding-bottom: .pxToRem(75) [];
        .cell {
            background: #ffffff;
            box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
            margin-bottom: .pxToRem(20) [];
            padding: .pxToRem(30) [];
            border-radius: .pxToRem(40) [];
            box-sizing: border-box;
            .name {
                font-size: .pxToRem(30) [];
                height: .pxToRem(40) [];
                line-height: .pxToRem(40) [];
                font-weight: bold;
                display: flex;
                .txt {
                    flex: 1;
                    box-sizing: border-box;
                    max-width: .pxToRem(690) [];
                    display: inline-block;
                    .overflow(1);
                }
                .distance {
                    padding-left: .pxToRem(30) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    &::before {
                        content: ' ';
                        .base-center-y;
                        left: 0;
                        .sq(24);
                        background: url('~@/assets/icons/icon-address.png');
                        background-size: cover;
                    }
                }
            }
            .addr {
                color: rgba(0, 0, 0, 0.5);
                font-size: .pxToRem(24) [];
                margin-top: .pxToRem(40) [];
                height: .pxToRem(36) [];
                line-height: .pxToRem(36) [];
                .overflow(1);
            }
            .lab-list {
                display: flex;
                align-items: center;
                margin-top: .pxToRem(10) [];
                font-size: 0;
                .lab-item {
                    display: inline-block;
                    height: .pxToRem(34) [];
                    margin-right: .pxToRem(10) [];
                    line-height: .pxToRem(34) [];
                    padding: 0 .pxToRem(16) [];
                    box-sizing: border-box;
                    font-size: .pxToRem(20) [];
                    border-radius: .pxToRem(8) [];
                    border: .pxToRem(1) [] solid rgba(0, 0, 0, 0);
                    &.subsidy {
                        width: .pxToRem(88) [];
                        height: .pxToRem(34) [];
                        padding: 0;
                        .image {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    &.red {
                        color: #f7b500;
                        border: .pxToRem(1) [] solid #f8c32f;
                    }
                    &.blue {
                        color: #92a7f3;
                        border: .pxToRem(1) [] solid #92a7f3;
                    }
                    &.green {
                        color: #49c376;
                        border: .pxToRem(1) [] solid #49c376;
                    }
                }
            }
        }
    }
    .location {
        position: fixed;
        width: 100vw;
        line-height: .pxToRem(78) [];
        background: #f0f0f0;
        left: 0px;
        bottom: 0px;
        color: rgba(0, 0, 0, 0.9);
        font-size: .pxToRem(26) [];
        padding-left: .pxToRem(30) [];
        padding-right: .pxToRem(30) [];
        box-sizing: border-box;
        z-index: 10;
        > div {
            padding-bottom: @tabbarHeight;
        }
        .img {
            .sq(32);
            // vertical-align: middle;
            // margin-right: .pxToRem(10) [];
        }
        .txt {
            height: .pxToRem(78) [];
            line-height: .pxToRem(78) [];
            padding-left: .pxToRem(42) [];
            &::before {
                content: ' ';
                .base-center-y;
                left: 0;
                margin-top: .pxToRem(-2) [];
                .sq(32);
                background: url('~@/assets/icons/icon-address.png');
                background-size: cover;
            }
        }
        .rs-lc {
            float: right;
            height: .pxToRem(78) [];
            line-height: .pxToRem(78) [];
            padding-right: .pxToRem(40) [];
            &::after {
                content: ' ';
                .base-center-y;
                right: .pxToRem(0) [];
                margin-top: .pxToRem(-2) [];
                .sq(32);
                background: url('~@/assets/icons/icon-rotate.png');
                background-size: cover;
            }
            &.loading {
                &::after {
                    background: url('~@/assets/icons/icon-rotate-loading.png');
                    background-size: cover;
                }
            }
        }
    }
    .noList {
        text-align: center;
        margin-top: .pxToRem(100) [];
        color: rgba(153, 153, 153, 1);
        font-size: .pxToRem(30) [];
    }
}
</style>
